import React from "react";
import PropTypes from "prop-types";

import Main from "src/app/components/Main/Main";
import Aside from "src/app/components/Aside/Aside";
import Card from "../../components/Card/Card";
import HelpTopics from "../../components/HelpTopics/HelpTopics";
import AsideSearch from "../../components/AsideSearch/AsideSearch";
import GetInTouch from "../../components/GetInTouch/GetInTouch";
import ErrorBox from "../../components/ErrorBox/ErrorBox";
import styles from "./ErrorPage500.module.css";
import errorMessagesConfig from "../../../config/errorMessages";

const ErrorPage = ({ content, storeData }) => {
  if (storeData) {
    const errorMessageData = errorMessagesConfig[storeData.storeCode];

    const {
      header = errorMessageData.header,
      description = errorMessageData.description,
    } = content?.data || {};

    return (
      <div className={styles.errorContainer}>
        <div className={styles.errorBoxContainer}>
          <ErrorBox
            header={header}
            description={description}
            status={500}
            errorType="Sitecore API"
          />
        </div>
      </div>
    );
  } else {
    const { header, description, button } = content.data.main.body.elements[0];

    return (
      <>
        <Main>
          <Card type="main">
            <ErrorBox
              header={header}
              description={description}
              status={content.status}
              errorType="Sitecore page not found"
              showHomepagebutton={true} //content.data.main.body.elements[0].button
              buttonData={button}
            />
          </Card>
        </Main>
        {!storeData && (
          <Aside>
            {content.data.aside.topics && (
              <Card type="aside">
                <HelpTopics data={content.data.aside.topics} />
              </Card>
            )}
            {content.data.aside["search-box"] && (
              <Card type="aside">
                <AsideSearch
                  data={content.data.aside["search-box"].elements[0]}
                />
              </Card>
            )}
            {content.data.aside["get-in-touch"] && (
              <Card type="aside">
                <GetInTouch
                  data={content.data.aside["get-in-touch"].elements[0]}
                />
              </Card>
            )}
          </Aside>
        )}
      </>
    );
  }
};

export default ErrorPage;

ErrorPage.propTypes = {
  content: PropTypes.object,
  storeData: PropTypes.object,
};
